import React, { useMemo } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { ff } from '@atlassian/jira-feature-flagging';
import { ALLOWED_EXTERNAL_CONTROLS } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/constants';
import type { ExternalControlsType } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import { useExternalControlsAPI } from '../../../../controllers/use-external-controls-api';
import type { FormAPI } from '../../../../controllers/use-external-controls-api/types';

type Props = {
	externalControls: ExternalControlsType;
} & FormAPI;

const Controls = ({ externalControls, getFormState, setFieldValue }: Props) => {
	const formAPI = useMemo(
		() => ({
			getFormState,
			setFieldValue,
		}),
		[getFormState, setFieldValue],
	);
	const { fieldAPI, getFormFieldValue } = useExternalControlsAPI(formAPI);
	const { Component } = externalControls;

	return <Component fieldAPI={fieldAPI} getFormFieldValue={getFormFieldValue} />;
};

export const ExternalControlsRenderer = ({
	externalControls,
	getFormState,
	setFieldValue,
}: Partial<Props>) => {
	if (
		ff('external-controls-in-gic_9125o') &&
		externalControls &&
		getFormState &&
		setFieldValue &&
		ALLOWED_EXTERNAL_CONTROLS.TRIGGER_POINTS.includes(externalControls.triggerPoint)
	) {
		return (
			<JSErrorBoundary
				id="externalControlsRenderer"
				packageName="jiraIssueCreate"
				fallback="unmount"
			>
				<Controls
					externalControls={externalControls}
					getFormState={getFormState}
					setFieldValue={setFieldValue}
				/>
			</JSErrorBoundary>
		);
	}

	return null;
};
